const getAffectedAssets = (rootState) => rootState.ws.saving.assets;

export default getAffectedAssets;
